(async() => {
    const { Core } = await importModule('Core');

    customElements.define('main-navigation-mobile', class extends Core {
        elements = {
            stage: '[data-stage]',
            navItems: '*[data-to-lvl]',
            dataMenuTriggerMB:'*[data-mb-submenu]',
            dataBack:'*[data-mb-back]',
            dataAccordion:'*[data-accordion]'
        }

        render() {
            this._handleNavigation();
        }
        
        _handleNavigation() {
            this.$dataMenuTriggerMB.map((item) => {

                $(item).on('click',function() {
                    $(this).parent().next('.sub-menu').addClass('open');
                    $(this).attr('aria-expanded','true');
                    $(this).closest('li').siblings().attr({'aria-hidden':'true','tabindex':'-1'});  
                    _theme.focusTrap($(this).parent().next('.sub-menu'),function() {
                        $(this).closest('li').find('[data-mb-submenu]').attr('aria-expanded','false')
                        $('main-navigation-mobile').find('li').siblings().removeAttr('aria-hidden tabindex');  
                    },'summary'); 
                })

            })
            this.$dataBack.map((item) => {
                $(item).on('click',function() {
                    $(this).closest('.sub-menu').removeClass('open');
                    $(this).closest('li').find('[data-mb-submenu]').attr('aria-expanded','false').focus(); 
                    $(this).closest('li').siblings().removeAttr('aria-hidden tabindex');
                });
            })

            this.$dataAccordion.map((item)=>{

                $(item).find('ul').slideUp();

                $(item).find('button').on('click',function() {
                    $(this).attr('aria-expanded')  == 'false' ? $(this).attr('aria-expanded','true') : $(this).attr('aria-expanded','false')
                    $(this).next().find('ul').slideToggle(); 
                })

            })
        }
    });

})()